import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./MentorsList.css";

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

function MentorsList() {
    const [mentors, setMentors] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOption, setSortOption] = useState("name");
    const [searchParams] = useSearchParams();
    const category = searchParams.get("category");
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch mentors from the backend
        const fetchMentors = async () => {
            try {
                const url = category
                    ? `${BASE_URL}/mentor/getMentorsDetails.php?category=${category}`
                    : `${BASE_URL}/mentor/getMentorsDetails.php`;
                const response = await fetch(url);
                const data = await response.json();
                const filteredMentors = data.filter(mentor => mentor.isApproved);
                setMentors(filteredMentors);
            } catch (error) {
                console.error("Error fetching mentors:", error);
            }
        };
        fetchMentors();
    }, [category]);

    const filteredMentors = mentors
        .filter((mentor) =>
            `${mentor.name} ${mentor.experience} ${mentor.category}`.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .sort((a, b) => {
            if (sortOption === "category") return b.category.localeCompare(a.category);
            if (sortOption === "rating") return b.rating - a.rating;
            return 0;
        });

    const handleBookClick = (mentorId) => {
        navigate(`/career-coach-profile/${mentorId}`); // Navigate to MentorDetails page
    };

    return (
        <div className="coaches-list-container">
            <div className="coaches-header">
                <input
                    type="text"
                    className="coaches-search-bar"
                    placeholder="Search Career Coaches..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <div>
                    <p className="sort-by-text">Sort by</p>
                    <select
                        className="coaches-sorting-dropdown"
                        value={sortOption}
                        onChange={(e) => setSortOption(e.target.value)}
                    >
                        <option value="category">Category</option>
                        <option value="rating">Rating</option>
                    </select>
                </div>
            </div>
            <div className="coaches-list">
                {filteredMentors.map((mentor) => (
                    <div key={mentor.mentorId} className="coach-card">
                        <img
                            src={`${BASE_URL}/images/profile/${mentor.profileImageName}`}
                            alt={mentor.name}
                            className="coach-image"
                        />
                        <div className="coach-info">
                            <h3 className="coach-name">{mentor.name}</h3>
                            <p className="coach-experience">
                                {mentor.experience} years of experience
                            </p>
                            <p className="coach-category">{mentor.category}</p>
                            <p className="coach-approval">
                                {mentor.isApproved ? "Approved" : "Pending Approval"}
                            </p>
                            <p className="coach-category">
                                ⭐{mentor.rating.toFixed(1)}
                            </p>
                        </div>
                        <button
                            className="coach-book-button"
                            onClick={() => handleBookClick(mentor.mentorId)}
                        >
                            Book</button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default MentorsList;
